import gsap from "gsap";
import { debounce } from "lodash";
import { makeHeaderRed, makeHeaderTransparent } from "../sections/header";

export function getDropdownHeight() {
  const announcementBar = document.querySelector("#announcement-bar-container");
  let announcementBarHeight = "0px";

  if (announcementBar instanceof HTMLElement) {
    announcementBarHeight = "30px";
  }

  if (window.innerWidth < 768) {
    return `calc(100% - var(--header-height, 80px) + ${announcementBarHeight})`;
  } else {
    return `calc(100% - var(--header-height, 80px) - 33% + ${announcementBarHeight})`;
  }
}

export function dropdownMenuV2(menuToggleButton) {
  const dropdownContainerOverlay = document.querySelector(
    ".dropdown-container-overlay"
  );

  const dropdownContainer = document.querySelector(".dropdown-container");

  let menuOpen;

  /* Get initial menu state */
  const hamburgerButton = menuToggleButton.querySelector(
    ".menu-icon-hamburger"
  );
  if (hamburgerButton.classList.contains("hidden")) {
    menuOpen = true;
  } else {
    menuOpen = false;
  }

  /* Set up the timeline */
  let tl = gsap
    .timeline({
      paused: true,
      onStart: () => {
        dropdownContainerOverlay.classList.remove("hidden");
        // hide announcement bar
        hideAnnouncementBar(dropdownContainerOverlay, dropdownContainer);
      },
      onComplete: () => {
        menuOpen = true;
        makeHeaderRed();
      },
      onReverseComplete: () => {
        dropdownContainerOverlay.classList.add("hidden");
        menuOpen = false;
        makeHeaderTransparent();

        tl.invalidate(); //avoid using resize event to recalculate the height
        showAnnouncementBar(dropdownContainerOverlay, dropdownContainer);
      },
    })
    .set(dropdownContainer, { height: 0 })
    .set(dropdownContainerOverlay, {
      height: "100%",
      opacity: 0,
    })
    .to(dropdownContainerOverlay, {
      opacity: 1,
      duration: 0.2,
    })
    .to(dropdownContainer, {
      height: getDropdownHeight,
      duration: 0.2,
    });

  menuToggleButton.addEventListener("click", () => {
    toggleIcon(menuToggleButton, menuOpen);
    if (menuOpen) {
      tl.reverse();
    } else {
      tl.play();
    }
  });
  /* TODO later: fix nav size when menu is open (very rare event) */
  /*   window.addEventListener(
    "resize",
    debounce(() => {
      console.log(
        window.getComputedStyle(dropdownContainer).height,
        // @ts-ignore
        dropdownContainer.style.height,
        getDropdownHeight()
      );
      // @ts-ignore
      if (dropdownContainer.style.height !== getDropdownHeight()) {
        gsap.to(dropdownContainer, {
          height: getDropdownHeight,
          duration: 0, // TODO add duration for transition but fix the height first(!) to avoid jumps
          onComplete: () => {
            // Sshould only do it when the height is different
            console.count("adjusted dropdown height");
          },
        });
      }
    }, 200)
  ); */
  dropdownContainerOverlay.addEventListener("click", (e) => {
    if (e.target !== e.currentTarget) {
      return;
    } else {
      toggleIcon(menuToggleButton, true);
      tl.reverse();
    }
  });

  const dropdownMenuLinks = Array.from(
    document.querySelectorAll(".dropdown-menu-link")
  );

  handleSubmenu(dropdownMenuLinks);

  // On resize
  window.addEventListener(
    "resize",
    debounce(() => {
      handleSubmenu(dropdownMenuLinks);
    }, 200)
  );
}

function toggleIcon(button, isOpen) {
  const iconHamburger = button.querySelector(".menu-icon-hamburger");
  const iconClose = button.querySelector(".menu-icon-close");

  if (isOpen) {
    iconHamburger.classList.remove("hidden");
    iconClose.classList.add("hidden");
  } else {
    iconHamburger.classList.add("hidden");
    iconClose.classList.remove("hidden");
  }
}

function handleSubmenu(dropdownMenuLinks) {
  // For mobile: close all links & listen to cick event
  for (let link of dropdownMenuLinks) {
    const submenu = link.querySelector(".dropdown-menu__submenu");

    if (window.innerWidth < 768) {
      //1. For mobile: close all submenus
      link.classList.remove("submenu-open");
      let submenus = Array.from(
        document.querySelectorAll(".dropdown-menu__submenu")
      );
      for (let menu of submenus) {
        if (menu instanceof HTMLElement) {
          menu.style.height = "0px";
        }
      }

      // 2. Handle click
      /* let tl = gsap
        .timeline({
          paused: true,
          onStart: () => {},
          onComplete: () => {
            link.classList.add("submenu-open");
          },
          onReverseComplete: () => {
            link.classList.remove("submenu-open");
            //tl.invalidate(); //avoid using resize event to recalculate the height
          },
        })
        .set(submenu, { height: "0px" })
        .to(submenu, {
          height: "auto",
          duration: 0.2,
        });*/

      link.addEventListener("click", (e) => {
        //1. For mobile: close all other submenus
        for (let otherLink of dropdownMenuLinks) {
          if (
            otherLink.dataset.title !== e.target.parentElement.dataset.title
          ) {
            let submenu = otherLink.querySelector(".dropdown-menu__submenu");
            gsap.to(submenu, {
              height: "0px",
              onComplete: () => {
                otherLink.classList.remove("submenu-open");
              },
            });
          }
        }

        // 2.Handle clicks
        if (
          link.classList.contains("submenu-open") &&
          e.target.classList.contains("dropdown-menu__submenu-heading")
        ) {
          gsap.to(submenu, {
            height: "0px",
            duration: 0.2,
            onComplete: () => link.classList.remove("submenu-open"),
          });
        } else {
          gsap.to(submenu, {
            height: "auto",
            duration: 0.2,
            onComplete: () => link.classList.add("submenu-open"),
          });
        }
      });
    } else {
      //1. For desktop: open all submenus
      link.classList.add("submenu-open");
      let submenus = Array.from(
        document.querySelectorAll(".dropdown-menu__submenu")
      );
      for (let menu of submenus) {
        menu.style.height = "auto";
      }
    }
  }
}

export function hideAnnouncementBar(overlay, container) {
  const announcementBar = document.querySelector("#announcement-bar-container");
  if (announcementBar instanceof HTMLElement) {
    announcementBar.style.overflow = "hidden";
    // Update height
    overlay.style.top = "50px";
    container.style.top = "50px";

    gsap.to(announcementBar, {
      height: 0,
      duration: 0.2,
      ease: "expo",
    });
  }
}

export function showAnnouncementBar(overlay, container) {
  const announcementBar = document.querySelector("#announcement-bar-container");
  if (announcementBar instanceof HTMLElement) {
    // Update height
    overlay.style.top = "var(--header-height)";
    container.style.top = "var(--header-height)";

    gsap.to(announcementBar, {
      height: "30px",
      duration: 0.2,
      ease: "expo",
    });
  }
}
